import { useParams } from 'react-router-dom';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import { Link } from '@mui/material';
import { makeStyles } from '@mui/styles';
import pluralize from 'pluralize';
import { useEstateWorkItem_GetEstateWorkItemsCountsByPortalIdQuery } from 'queries';

import Spinner from 'common/spinner';
import { NotificationSeverity, showAlert } from 'utils/notification-manager';

const useStyles = makeStyles(() => ({
  link: {
    backgroundColor: '#1C2541',
    color: '#FFD700',
    border: '1px solid #FFD700',
    borderRadius: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginRight: '20px',
    fontSize: '14px',
    padding: '7px 10px',
  },
  icon: {
    marginRight: '5px',
  },
}));

const ActionNeededEstateWorkItemsCount = () => {
  const { portalId } = useParams<Record<string, string>>();
  const classes = useStyles();

  const { data: portalEstateWorkItemSummary } =
    useEstateWorkItem_GetEstateWorkItemsCountsByPortalIdQuery({
      fetchPolicy: 'network-only',
      notifyOnNetworkStatusChange: true,
      skip: !portalId,
      variables: {
        portalId,
      },
      onError: (e) => {
        showAlert({
          message: 'Error getting estate work items counts by portal ID: ' + e.message,
          severity: NotificationSeverity.ERROR,
        });
      },
    });

  if (!portalId) {
    return null;
  }

  if (!portalEstateWorkItemSummary?.data) {
    return <Spinner />;
  }

  const actionNeededEstateWorkItemsCount =
    portalEstateWorkItemSummary.data.actionNeededEstateWorkItemsCount;

  if (actionNeededEstateWorkItemsCount === 0) {
    return null;
  }

  return (
    <Link className={classes.link} href={`/home/${portalId}/assigned-tasks`} underline="none">
      <WarningAmberOutlinedIcon fontSize="small" className={classes.icon} />
      {actionNeededEstateWorkItemsCount} {pluralize('Action', actionNeededEstateWorkItemsCount)}{' '}
      Needed
    </Link>
  );
};

export default ActionNeededEstateWorkItemsCount;
